
export const parseGpxParser = async (gpxFile: string | File): Promise<Document | undefined> => {
    if (!gpxFile) {
        return;
    }
    if (typeof gpxFile === 'string') {
        const response = await fetch(gpxFile);
        const gpxText = await response.text();
        const parser = new DOMParser();

        return  parser.parseFromString(gpxText, "application/xml");
    }
    if (gpxFile instanceof File) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e) => {
                if (e.target?.result) {
                    const parser = new DOMParser();
                    const xml = parser.parseFromString(e.target.result as string, 'application/xml');
                    resolve(xml);
                } else {
                    reject(new Error("Erreur de lecture du fichier GPX"));
                }
            };

            reader.onerror = () => {
                reject(new Error("Erreur lors de la lecture du fichier"));
            };

            reader.readAsText(gpxFile);
        });
    }
}
